import { ArticleOutlined } from '@mui/icons-material';
import { Box, Stack, Typography, Paper, Divider } from '@mui/material';
import { styled } from '@mui/system';
import PrimaryButton from 'components/buttons/PrimaryButton';
import useAuth from 'hooks/useAuth';
import Add from 'icons/Add';
import DashboardLayout from 'layouts/Dashboard/DashboardLayout';
import ListSubmissionUserTable from 'page-sections/submissions/user-submissions/list';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MyAbstractListService from 'services/abstract/MyAbstractListService';
import axiosInstance from 'utils/axios';
import FormatDate from 'utils/formatDate';
import isValidDate from 'utils/isValidDate';
import { searchByName } from 'utils/utils';
import { TutorialVideo } from 'views/LandingPage/AbstractSubmission/components';

const StyledStack = styled(Stack)(({ theme }) => ({
    [theme.breakpoints.down(565)]: {
        width: '100%',
    },
}));

const AbstractList = () => {
    const [endPeriod, setEndPeriod] = useState();
    const { user } = useAuth();
    const { listData, loading } = MyAbstractListService(user?.id);
    let navigate = useNavigate();

    const [disableButtonSumit, setDisableButtonSubmit] = useState(false);
    const [filteredItem, setFilteredItem] = useState([]);
    const getData = async () => {
        await axiosInstance
            .get('api/system-parameters/name/end_off_submission_period')
            .then(({ data }) => {
                setEndPeriod(FormatDate(data.value, 'MMMM do, yyyy'));
                setDisableButtonSubmit(!isValidDate(data.value));
            })
            .catch((err) => console.log(err));
    };
    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        const result = searchByName(listData, '');
        setFilteredItem(result);
    }, [listData]);

    return (
        <DashboardLayout>
            <Box pt={2} pb={4}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography
                        variant="h4"
                        color="text.primary"
                        align={'left'}
                        gutterBottom
                        sx={{
                            fontWeight: 700,
                            mt: 3,
                            mb: 2,
                        }}
                    >
                        Abstract Submission
                    </Typography>
                    <StyledStack alignItems="center" direction="row" gap={2}>
                        <PrimaryButton
                            onClick={() =>
                                navigate('/dashboard/abstract-create')
                            }
                            variant="contained"
                            disabled={disableButtonSumit}
                            sx={{
                                minWidth: 220,
                            }}
                        >
                            <Add />
                            {disableButtonSumit
                                ? 'Submission Close'
                                : 'New Submission'}
                        </PrimaryButton>
                    </StyledStack>
                </Stack>

                <Paper
                    sx={{
                        p: 3,
                        mt: 2,
                        borderRadius: 2,
                        boxShadow: '0 6px 24px rgba(34, 42, 53, 0.06)',
                    }}
                >
                    <Typography
                        variant="h6"
                        color="text.primary"
                        gutterBottom
                        sx={{ fontWeight: 700 }}
                    >
                        Abstract List
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    {!loading && (
                        <ListSubmissionUserTable
                            listSubmissionUserList={filteredItem}
                        />
                    )}
                </Paper>

                <Paper
                    sx={{
                        p: 3,
                        mt: 4,
                        borderRadius: 2,
                        boxShadow: '0 6px 24px rgba(34, 42, 53, 0.06)',
                    }}
                >
                    <Typography
                        variant="h6"
                        color="text.primary"
                        gutterBottom
                        sx={{ fontWeight: 700 }}
                    >
                        Case Report, Research Articles, and Systematic Review /
                        Meta-Analysis
                    </Typography>
                    <Stack spacing={1.5}>
                        <Typography>
                            1. Abstracts must be written in the American English
                            Language.
                        </Typography>
                        <Typography>
                            2. All Case, Systematic Review / Meta-Analisys, and
                            Research Abstracts must be submitted prior{' '}
                            {endPeriod}
                        </Typography>
                        <Typography>
                            3. For Guidelines for Submission please click below:
                        </Typography>
                    </Stack>
                    <Box
                        display={'flex'}
                        flexWrap={'wrap'}
                        justifyContent={'center'}
                        mt={3}
                    >
                        <Link
                            to="/assets/Abstract Guideline InaACC 2026.pdf"
                            target="_blank"
                            download
                            style={{ textDecoration: 'none' }}
                        >
                            <PrimaryButton
                                variant="contained"
                                color="primary"
                                sx={{ display: 'flex', gap: 2 }}
                            >
                                <ArticleOutlined />
                                Abstract Guidelines
                            </PrimaryButton>
                        </Link>
                    </Box>
                </Paper>

                <TutorialVideo />
            </Box>
        </DashboardLayout>
    );
};

export default AbstractList;
